import { Grid } from "@mui/material"
import { AnalyticsTabs } from "components/Analytics/AnalyticsTabs"

export function Analytics() {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <AnalyticsTabs />
      </Grid>
    </Grid>
  )
}
